// import MatchHeight from "./matchHeight";

(() => {
  window.addEventListener("load", function () {
    document.body.classList.add("is-load");
    document.querySelector("main").classList.add("is-load");
  });
})();

// ご利用の流れスライダー
const swiperEsDom = document.querySelector(".js-p-top-es-swiper");
let swiperEs;

const swiperEsOptions = {
  slidesPerView: 1.4,
  centeredSlides: true,
  pagination: {
    el: ".js-p-top-es-swiper-pagination",
    clickable: true,
  },
};

const createEsSwiper = () => {
  if (!swiperEs) swiperEs = new Swiper(swiperEsDom, swiperEsOptions);
};

const destroyEsSwiper = () => {
  if (swiperEs) {
    swiperEs.destroy(false, true);
    swiperEs = null;
  }
};

const handleMediaQuery = (event) => {
  if (event.matches) {
    createEsSwiper();
    // createInterviewSwiper();
  } else {
    destroyEsSwiper();
    // destroyInterviewSwiper();
  }
};

const mediaQuery = window.matchMedia("(max-width: 768px)");

window.addEventListener("load", () => handleMediaQuery(mediaQuery));
mediaQuery.addEventListener("change", handleMediaQuery);



// 招待状のサンプルスライダー
const swiperUseSampleDom = document.querySelector(".js-p-use-sample-swiper");
let swiperUseSample;

const swiperUseSampleOptions = {
  slidesPerView: 1.2,
  centeredSlides: true,
  initialSlide: 0,        // 1枚目から開始

  loop: true, // 無限ループ
  // loopAdditionalSlides: 1,   // ループ用に余分な複製スライドを作成
  autoplay: {
    delay: 3000, // 3秒ごとにスライド
    disableOnInteraction: false, // ユーザー操作後も自動再開
  },
  pagination: {
    el: ".js-p-use-sample-swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: '.p-sample-swiper-next',
    prevEl: '.p-sample-swiper-prev',
  },
  // slidesPerView: 1.2,     // 1枚ちょっと見せる
  // centeredSlides: true,   // 常に中央配置
  initialSlide: 0,        // 1枚目から開始
  spaceBetween: 16,       // スライド間の余白
};

const createUseSampleSwiper = () => {
  if (!swiperUseSample && swiperUseSampleDom) swiperUseSample = new Swiper(swiperUseSampleDom, swiperUseSampleOptions);
};

const destroyUseSampleSwiper = () => {
  if (swiperUseSample) {
    swiperUseSample.destroy(false, true);
    swiperUseSample = null;
  }
};

const handleMediaQueryUseSample = (event) => {
  if (event.matches) {
    createUseSampleSwiper();
  } else {
    destroyUseSampleSwiper();
  }
};

const mediaQueryUseSample = window.matchMedia("(max-width: 768px)");

window.addEventListener("load", () => handleMediaQueryUseSample(mediaQueryUseSample));
mediaQueryUseSample.addEventListener("change", handleMediaQueryUseSample);
